import React from "react";
import PageHero from "@/components/shared/PageHero";
import ContactSection from "@/components/sections/ContactSection";
import FAQSection from "@/components/sections/FAQSection";

export default function ContactPage() {
    return (
        <>
            <PageHero
                testId="contact-page"
                eyebrow="Contact"
                chapter="Reach · 01"
                title="Contact us."
                subtitle="Partnerships, press or platform feedback — send it here, and it'll land with the right person."
            />
            <ContactSection />
            <FAQSection />
        </>
    );
}
